import React from 'react';

const CARDS = [
    { image: require('../../../../images/landing-pages/angel-networks/better-signal-icon.png'), t: 'Better signal', d: 'Your IC sees only companies that have passed a structured readiness filter. Less noise. More signal.' },
    { image: require('../../../../images/landing-pages/angel-networks/faster-closes-icon.png'), t: 'Faster closes', d: 'A certified Diligence Pack is already in place before due diligence begins. Angels spend time deciding, not chasing documents.' },
    { image: require('../../../../images/landing-pages/angel-networks/first-mover-advantage-icon.png'), t: 'First-mover advantage', d: 'The networks that establish a quality standard now will attract better deal flow for years. The question is which network gets there first.' },
];

const AngelChangesSection = () => (
    <section className="lp-change-sec">
        <h2 className="lp-h2" data-lp-reveal style={{ textAlign: 'center', margin: '0 auto 52px', maxWidth: 680 }}>What changes for your network.</h2>
        <div className="lp-change-grid">
            {CARDS.map(({ image, t, d }, i) => (
                <div className="lp-change" key={i} data-lp-reveal data-lp-delay={i * 100}>
                    <div className="ic"><img src={image} alt="" /></div>
                    <h3>{t}</h3>
                    <p>{d}</p>
                </div>
            ))}
        </div>
    </section>
);

export default AngelChangesSection;
